module.exports = __webpack_public_path__ + "static/media/GitHubLogoDark.3a837036.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/GitHubLogoDark.svg
// module id = 1155
// module chunks = 0